angular.module('controllers').controller('driverController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$http', '$route', '$routeParams', '$location',
	function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $http, $route, $routeParams, $location) {
		$rootScope.path = '/driver';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'driver';
		$scope.pathTemplate = 'distribution/drivers';
		$scope.title = 'Soferi';
		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'driver_last_name';
		$scope.defaultItem = 10;
    $rootScope.typeId = 'id';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'driver_image':{'label':'Imagine', 'filter':0},
			'driver_last_name':{'label': 'Nume', 'filter': 1, 'filterType': 'input'},
			'driver_first_name':{'label': 'Prenume', 'filter': 1, 'filterType': 'input'},
			'driver_cnp':{'label': 'CNP', 'filter': 1, 'filterType': 'input'},
			'driver_phone':{'label': 'Telefon', 'filter': 1, 'filterType': 'input'},
			'driver_email':{'label': 'Email', 'filter': 1, 'filterType': 'input'},
			//'car_id': {'label': 'Masina', 'filter': 1, 'filterType': 'select', 'associate': 1, 'relation': 'car', 'colRelation': 'car_no'},
			'car_no': {'label': 'Masina', 'filter': 1, 'filterType': 'select'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];
		$scope.search.order = 'asc';
		$scope.additionals['content_type'] = 'form-urlencoded';
		$scope.additionals['publicPath'] = '/images/drivers';
	  $scope.additionals['columnDisplay'] = 'driver_first_name';
    $scope.additionals['columnDisplaySec'] = 'driver_last_name';
		$scope.additionals['publicPathThumb250x250'] = $scope.additionals['publicPath']+'/thumb250x250';
		$scope.additionals['publicPathFile'] = '/files/drivers';

		/* get dependent fields */
		$scope.getDependedFields = function () {
			Crud.getDependedFields($scope.path)
				.success(function (data) {
					$scope.additionals['cars'] = data.cars;
					$scope.columns.car_no.options = [{id:'', value:''}];
					angular.forEach(data.cars, function (item, key) {
						$scope.columns.car_no.options.push({id:item.car_no, value:item.car_no +' ('+item.car_mark+')'});
					});
					$scope.additionals['car_no_string'] = JSON.stringify($scope.columns.car_no.options);
				});
		}

  	$scope.additionals['status_string'] = JSON.stringify($scope.columns.status.options);


		/* autocomplete */
		function createFilterFor(query) {
			var lowercaseQuery = angular.lowercase(query);
			return function filterFn(item) {
				return item.driver_name.indexOf(lowercaseQuery) >= 0;
			};
		}
		$scope.additionals['getDrivers'] = function() {
			Crud.get($scope.path+'/getDrivers')
				.success(function (data) {
					$scope.additionals['drivers'] = [];
					angular.forEach(data.drivers, function (item, key) {
						$scope.additionals['drivers'][key] = {
							'id': item['id'],
							'driver_name': item['driver_detail']['driver_first_name'].toLowerCase() + ' ' + item['driver_detail']['driver_last_name'].toLowerCase(),
							'display': item['driver_detail']['driver_first_name'] + ' ' + item['driver_detail']['driver_last_name']
						};
					});

					/* autocomplete */
					function querySearch(query) {
						var results = query ? $scope.additionals['drivers'].filter(createFilterFor(query)) : [];
						return results;
					}

					$scope.additionals['searchDriver'] = querySearch;
					$scope.additionals['errors'] = {};
					/* end autocomplete */
				});
		}

		/* end autocomplete */

		/* close field */
		$scope.additionals['closeField'] = function (paramName, paramId) {
			$scope.org[paramName] = '';
			$scope.org[paramId] = '';
		}

		$scope.additionals['searchTerm'];
		$scope.additionals['clearSearchTerm'] = function() {
			$scope.additionals['searchTerm'] = '';
		};
		$scope.additionals['onSearchChange'] = function(ev) {
			ev.stopPropagation();
		};

		/* add multiple forms */
		$scope.additionals['cloneItem'] = function (model) {
			var itemToClone = {};
			$scope.additionals[model].push(itemToClone);
		}
		$scope.additionals['removeItem']= function (itemIndex, model) {
			$scope.additionals[model].splice(itemIndex, 1);
			if (!angular.isUndefined($scope.files)) {
				$scope.files.splice(itemIndex, 1);
			}
		}

		/* delete existing image */
		$scope.additionals['deleteImage'] = function (ev, model) {
			model['route'] = 'deleteImage';
			Crud.post('form-urlencoded', model, $scope.path + '/deleteImage')
				.success(function () {
					$scope.modelData['user_image'] = '';
					$scope.modelData['image'] = '';
					angular.element(document.querySelector('#image')).attr("src", '');
					$scope.image = '';

					model['multipleImages'] = '';
					model['user_image'] = '';
					model['image'] = '';
					var currentElement = angular.element(ev.currentTarget);
					angular.element(document.querySelector('#crop' + currentElement[0]['id'] + ' #img')).css('display', 'none');
				}).error(function (data) {
				$scope.errors = data.errors;

			});
		}
		/* delete existing file */
		$scope.additionals['deleteFile'] = function (model) {
			model['route'] = 'deleteFile';
			Crud.post('form-urlencoded', model, $scope.path+'/deleteFile')
				.success(function (data) {
					if (!angular.isUndefined(data.invalid)) {
						$scope.additionals['invalid'] = data.invalid;
					} else {
						model['file'] = '';
					}
				}).error(function (data) {
				$scope.errors = data.errors;
			});
		}

		/* add files to model */
		$scope.addFilesModel = function (ev, path, model, section, mode_action) {
			if (!angular.isUndefined(mode_action)) {
				$scope.mode_action = mode_action;
			}

			if($scope.mode_action == 'page') {
				$scope.controlSH = true;
				$scope.action = 'addFiles';
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
				$scope.additionals['invalid'] = '';
				var currentModel = {};
				angular.forEach(model, function (item, key) {
					currentModel[key] = item;
				});
				$scope.modelData = currentModel;

				$scope.additionals['files'] = $scope.modelData.files;
				if($scope.additionals['files'].length == 0) {
					$scope.additionals['files'][0] = {};
				}

				$scope.cancel = function () {
					$scope.modelData = {};
					$scope.errors = {};
					$scope.controlSH = false;
				};

				$scope.files = [];
				$scope.addFiles = function () {
                    $scope.additionals['buttonDisabled'] = true;
					$scope.isLoading = true;
					$scope.post = new FormData();

					angular.forEach($scope.modelData, function (item, key) {
						if (key == 'files') {
							angular.forEach(item, function (itemFile, keyFile) {
								$scope.post.append('files[' + keyFile + '][id]', itemFile['id']);
								$scope.post.append('files[' + keyFile + '][driver_id]', $scope.modelData['id']);
								$scope.post.append('files[' + keyFile + '][file_title]', itemFile['file_title']);
								if ($scope.files.length > 0 && !angular.isUndefined($scope.files[keyFile])) {
									$scope.post.append('files[' + keyFile + '][file]', $scope.files[keyFile]['file']);
								}
							});
						}
						$scope.post.append('id', $scope.modelData['id']);
						$scope.post.append('route', 'files');
					});

					Crud.post('undefined', $scope.post, $scope.path + '/files')
						.success(function (data) {
							$scope.isLoading = false;
							if (!angular.isUndefined(data.invalid)) {
								$scope.additionals['invalid'] = data.invalid;
							} else {
								angular.forEach($scope.modelData.files, function (item, key) {
									$scope.modelData.files[key] = data.modelFile[key];
								});
							}
							$scope.errors = {};
							$scope.isLoading = false;
							$scope.controlSH = false;
                            $scope.additionals['buttonDisabled'] = false;
						})
						.error(function (data) {
							$scope.isLoading = false;
							$scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
						});
				}
			}

			if($scope.mode_action == 'dialog') {
				$scope.additionals['invalid'] = '';
				var currentModel = {};
				angular.forEach(model, function (item, key) {
					currentModel[key] = item;
				});
				$mdDialog.show({
					controller: DialogController,
					templateUrl: 'fileDialog.tmpl.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose: true,
					locals: {
						pathTemplate: $scope.pathTemplate,
						section: section,
						model: currentModel,
						selected: $scope.selected,
						additionals: $scope.additionals
					}
				}).then(function () {
					if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
						if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models.data)) {
							$scope.getElement($scope.models.data, currentModel, $rootScope.typeId);
						}
						if (!angular.isUndefined($scope.modelData)) {
							$scope.modelData = currentModel;
						}
					}
				});
				DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'section', 'model', 'selected', 'additionals'];
				function DialogController($scope, $mdDialog, pathTemplate, section, model, selected, additionals) {
					$scope.pathTemplate = pathTemplate;
					$scope.modelData = model;
					$scope.additionals = additionals;
					$scope.selected = selected;
					$scope.section = section;

					$scope.cancel = function () {
						$mdDialog.cancel();
					};

					$scope.additionals['files'] = $scope.modelData.files;
					if (!angular.isUndefined($scope.additionals['files'])) {
						if ($scope.additionals['files'].length == 0) {
							$scope.additionals['files'][0] = {};
						}
					}

					$scope.files = [];
					$scope.addFiles = function () {
                        $scope.additionals['buttonDisabled'] = true;
						$scope.isLoading = true;
						$scope.post = new FormData();

						angular.forEach($scope.modelData, function (item, key) {
							if (key == 'files') {
								angular.forEach(item, function (itemFile, keyFile) {
									$scope.post.append('files[' + keyFile + '][id]', itemFile['id']);
									$scope.post.append('files[' + keyFile + '][driver_id]', $scope.modelData['id']);
									$scope.post.append('files[' + keyFile + '][file_title]', itemFile['file_title']);
									if ($scope.files.length > 0 && !angular.isUndefined($scope.files[keyFile])) {
										$scope.post.append('files[' + keyFile + '][file]', $scope.files[keyFile]['file']);
									}
								});
							}
							$scope.post.append('id', $scope.modelData['id']);
							$scope.post.append('route', 'files');
						});
						Crud.post('undefined', $scope.post, path + '/files')
							.success(function (data) {

								$scope.isLoading = false;
								if (!angular.isUndefined(data.invalid)) {
									$scope.additionals['invalid'] = data.invalid;
								} else {
									angular.forEach($scope.modelData.files, function (item, key) {
										$scope.modelData.files[key] = data.modelFile[key];
									});
								}
								$scope.errors = {};
								$scope.isLoading = false;
								$mdDialog.hide();
                                $scope.additionals['buttonDisabled'] = false;
							})
							.error(function (data) {
								$scope.isLoading = false;
								$scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
							});
					}
				}
			}
		};

        /* add password to model */
        $scope.additionals['controlShowPassword'] = 'password';
        $scope.additionals['showPassword'] = function () {
        	if($scope.additionals['controlShowPassword'] == 'password') {
                $scope.additionals['controlShowPassword'] = 'text';
            } else {
                $scope.additionals['controlShowPassword'] = 'password';
			}
        }
        $scope.addPasswordModel = function (ev, path, model, section, mode_action) {
            if (!angular.isUndefined(mode_action)) {
                $scope.mode_action = mode_action;
            }

            if($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'addPassword';
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
                $scope.additionals['invalid'] = '';
                var currentModel = {};
                angular.forEach(model, function (item, key) {
                    currentModel[key] = item;
                });
                $scope.modelData = currentModel;

                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };

                $scope.addPassword= function () {
                    $scope.additionals['buttonDisabled'] = true;
                    $scope.isLoading = true;
                    $scope.post = $scope.modelData;
                    $scope.post['route'] = 'password';

                    Crud.post('form-urlencoded', $scope.post, $scope.path + '/password')
                        .success(function (data) {
                            $scope.isLoading = false;
                            if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                            }
                            $scope.errors = {};
                            $scope.isLoading = false;
                            $scope.controlSH = false;
                            $scope.additionals['buttonDisabled'] = false;
                        })
                        .error(function (data) {
                            $scope.isLoading = false;
                            $scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
                        });
                }
            }

            if($scope.mode_action == 'dialog') {
                $scope.additionals['invalid'] = '';
                var currentModel = {};
                angular.forEach(model, function (item, key) {
                    currentModel[key] = item;
                });
                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'passwordDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        pathTemplate: $scope.pathTemplate,
                        section: section,
                        model: currentModel,
                        selected: $scope.selected,
                        additionals: $scope.additionals
                    }
                }).then(function () {
                    if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models.data)) {
                            $scope.getElement($scope.models.data, currentModel, $rootScope.typeId);
                        }
                        if (!angular.isUndefined($scope.modelData)) {
                            $scope.modelData = currentModel;
                        }
                    }
                });
                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'section', 'model', 'selected', 'additionals'];
                function DialogController($scope, $mdDialog, pathTemplate, section, model, selected, additionals) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.modelData = model;
                    $scope.additionals = additionals;
                    $scope.selected = selected;
                    $scope.section = section;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    $scope.addPassword = function () {
                        $scope.additionals['buttonDisabled'] = true;
                        $scope.isLoading = true;
                        $scope.post = $scope.modelData;
                        $scope.post['route'] = 'password';

                        Crud.post('form-urlencoded', $scope.post, path + '/password')
                            .success(function (data) {
                                $scope.isLoading = false;
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                }
                                $scope.errors = {};
                                $scope.isLoading = false;
                                $mdDialog.hide();
                                $scope.additionals['buttonDisabled'] = false;
                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
                            });
                    }
                }
            }
        };

		$scope.additionals['function']= function(ev, data) {
			angular.element(document.querySelector('#fileImage')).val('');
		}

		$scope.additionals['functionResult']= function(ev, data) {
		}

		/* delete existing image */
		$scope.additionals['deleteImage'] = function (ev, model) {
			model['route'] = 'deleteImage';
			Crud.post('form-urlencoded', model, $scope.path + '/deleteImage')
				.success(function () {
					$scope.modelData['driver_image'] = '';
					$scope.modelData['image'] = '';
					angular.element(document.querySelector('#image')).attr("src", '');
					$scope.image = '';

					model['multipleImages'] = '';
					model['driver_image'] = '';
					model['image'] = '';
					var currentElement = angular.element(ev.currentTarget);
					angular.element(document.querySelector('#crop' + currentElement[0]['id'] + ' #img')).css('display', 'none');
				}).error(function (data) {
				$scope.errors = data.errors;

			});
		}

		/* show setting */
		$scope.showSetting = function (ev, path, model) {

			$scope.additionals['buttonDisabled'] = true;

			if($scope.mode_action == 'page') {
				$scope.controlSH = true;
				$scope.action = 'showSetting';
				angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");

				$scope.modelData = {};
				$scope.cancel = function () {
					$scope.modelData = {};
					$scope.errors = {};
					$scope.controlSH = false;
				};
				if (!angular.isUndefined($scope.additionals['function'])) {
					$scope.additionals['function'](ev, $scope.modelData);
				}
				Crud.get($scope.path+'/showSetting/?id='+model)
					.success(function (data) {
						$scope.modelData = data;
						$scope.additionals['buttonDisabled'] = false;
					});
			}
			if($scope.mode_action == 'dialog') {
				Crud.get($scope.path+'/showSetting/?id='+model)
					.success(function (data) {
						$mdDialog.show({
							controller: DialogController,
							templateUrl: 'showSettingDialog.tmpl.html',
							parent: angular.element(document.body),
							targetEvent: ev,
							clickOutsideToClose: true,
							locals: {
								pathTemplate: $scope.pathTemplate,
								model: data,
								formatText: $scope.formatText,
								formatDate: $scope.formatDate,
								columns: $scope.columns,
								additionals: $scope.additionals
							},
						});
						DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'formatText', 'formatDate', 'columns', 'additionals'];
						function DialogController($scope, $mdDialog, pathTemplate, model, formatText, formatDate, columns, additionals) {
							$scope.pathTemplate = pathTemplate;
							$scope.modelData = model;
							$scope.additionals = additionals;
							$scope.formatText = formatText;
							$scope.formatDate = formatDate;
							$scope.columns = columns;
							$scope.currency = $rootScope.currency;

							$scope.cancel = function () {
								$mdDialog.cancel();
							};
						}
						$scope.additionals['buttonDisabled'] = false;
					}).error(function (data) {
					$scope.errors = data.errors;
					$scope.additionals['buttonDisabled'] = false;
				});
			}
		};

		/* update thumbs */
		$scope.updateThumbs = function (ev, path, modelId) {
			$scope.additionals['invalid'] = '';
			$scope.modelData = {};
			$mdDialog.show({
				controller: DialogController,
				templateUrl: 'updateThumbsDialog.tmpl.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {pathTemplate: $scope.pathTemplate, path: $scope.path, modelId: modelId, additionals: $scope.additionals}
			}).then();

			DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'path', 'modelId', 'additionals'];
			function DialogController($scope, $mdDialog, pathTemplate, path, modelId, additionals) {
				$scope.pathTemplate = pathTemplate;
				$scope.cancel = function () {
					$mdDialog.cancel();
				};
				$scope.additionals = additionals;
				$scope.path = path;

				$scope.additionals['buttonDisabled'] = true;
				$scope.isLoading = true;
				var post = {};
				post['driver_id'] = modelId;
				post['route'] = 'updateThumbs';
				Crud.post('form-urlencoded', post, $scope.path + '/updateThumbs')
					.success(function (data) {
						if (!angular.isUndefined(data.invalid)) {
							$scope.additionals['invalid'] = data.invalid;
						} else {
							if (!angular.isUndefined($scope.additionals['functionResult'])) {
								$scope.additionals['functionResult'](ev, data);
							}
						}
						$scope.isLoading = false;
						$scope.additionals['buttonDisabled'] = false;
					})
					.error(function (data) {
						$scope.errors = data.errors;
						$scope.isLoading = false;
						$scope.additionals['buttonDisabled'] = false;

					});
			}
		};

		/* detail model */
		$rootScope.detailDriver = function () {
			$scope.mode_action = 'dialog';
			Crud.show($routeParams.id, $scope.path)
				.success(function (data) {
					$scope.modelData = data;
				});
			Crud.get($scope.path+'/showSetting/?id='+$routeParams.id)
				.success(function (data) {
					$scope.settingModelData = data;

				});
		}


	}]
);
